import { apiFetch } from './client';

export const getTasks = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return apiFetch(`/api/tasks${qs ? '?' + qs : ''}`);
};

export const getTask = (id) => apiFetch(`/api/tasks/${id}`);

export const updateTask = (id, body) =>
  apiFetch(`/api/tasks/${id}`, { method: 'PATCH', body: JSON.stringify(body) });

export const getTaskResources = (id) => apiFetch(`/api/tasks/${id}/resources`);
